export default __webpack_public_path__ + "static/media/SCPLogo.f1d9e04a.png";